import { Box, Container, Grid, Typography } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import CEOImage from "../../assets/TeamLead/lead1Notbg.png";

const MotionBox = motion(Box);

const CEOSection = () => {
  const { scrollYProgress } = useScroll();
  const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "-6%"]);

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "var(--color-bg)",
        py: { xs: 3, md: 6 },
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
          {/* IMAGE */}
          <Grid item xs={12} md={5}>
            <MotionBox
              style={{ y: imageY }}
              sx={{
                maxWidth: 420,
                mx: { xs: "auto", md: 0 },
                position: "relative",
                aspectRatio: "3 / 4",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={CEOImage}
                alt="Mosaab Al Halabi - CEO Vision X Nexus"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 18px 35px rgba(0,0,0,0.25))",
                }}
              />
            </MotionBox>
          </Grid>

          {/* CONTENT */}
          <Grid item xs={12} md={7}>
            {/* GOLD RULE */}
            <MotionBox
              initial={{ width: 0, opacity: 0 }}
              whileInView={{ width: 64, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              sx={{
                height: 2,
                backgroundColor: "var(--color-gold)",
                mb: 3,
              }}
            />

            {/* BADGE */}
            <Box
              sx={{
                display: "inline-block",
                px: 2.5,
                py: 0.8,
                mb: 2,
                borderRadius: 999,
                border: "1px solid rgba(207,172,106,0.45)",
                fontSize: "0.7rem",
                letterSpacing: "2px",
                color: "var(--color-text-muted)",
              }}
            >
              EXECUTIVE LEADERSHIP
            </Box>

            <Typography
              sx={{
                color: "var(--color-text-primary)",
                fontWeight: 600,
                fontSize: { xs: "2rem", md: "2.6rem" },
                mb: 0.5,
              }}
            >
              Mosaab Al Halabi
            </Typography>

            <Box
              sx={{
                width: 48,
                height: 2,
                backgroundColor: "var(--color-gold)",
                mb: 2,
              }}
            />

            <Typography
              sx={{
                color: "var(--color-gold)",
                fontWeight: 500,
                mb: 4,
              }}
            >
              Chief Executive Officer
            </Typography>

            {/* VALUES */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  sm: "repeat(4, auto)",
                },
                gap: 1.5,
                mb: 4,
                maxWidth: "fit-content",
              }}
            >
              {["Integrity", "Vision", "Precision", "Trust"].map((item) => (
                <Box
                  key={item}
                  sx={{
                    px: 2.5,
                    py: 0.9,
                    borderRadius: 999,
                    border: "1px solid rgba(207,172,106,0.35)",
                    fontSize: "0.75rem",
                    letterSpacing: "1px",
                    color: "var(--color-text-primary)",
                    textAlign: "center",
                  }}
                >
                  {item}
                </Box>
              ))}
            </Box>

            {/* TEXT */}
            <Typography sx={bodyText}>
              At Vision X Nexus, we are dedicated to redefining the luxury real
              estate experience across the UAE. Our foundation is built on
              trust, integrity, and an uncompromising pursuit of excellence.
            </Typography>

            <Typography sx={bodyMuted}>
              We believe real estate is not simply about properties, but about
              creating spaces that reflect ambition, lifestyle, and long-term
              value.
            </Typography>

            <Typography sx={bodyMuted}>
              Our vision is to lead the future of luxury real estate by setting
              new industry standards and building lasting relationships.
            </Typography>

            {/* QUOTE */}
            <Box
              sx={{
                mt: 6,
                pl: 3,
                borderLeft: "2px solid var(--color-gold)",
              }}
            >
              <Typography
                sx={{ fontStyle: "italic", color: "var(--color-text-muted)" }}
              >
                “We don’t follow the market — we define it.”
              </Typography>
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "0.75rem",
                  letterSpacing: "2px",
                  color: "var(--color-text-muted)",
                }}
              >
                — VISION X NEXUS
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CEOSection;

/* ------------------ styles ------------------ */

const bodyText = {
  color: "var(--color-text-primary)",
  lineHeight: 1.9,
  mb: 3,
  maxWidth: 640,
};

const bodyMuted = {
  color: "var(--color-text-muted)",
  lineHeight: 1.9,
  mb: 3,
  maxWidth: 640,
};
